/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../axios-client";
import type { Client, RequestConfig, ResponseErrorConfig } from "../../axios-client";
import type { GetApiBookingSequentialSlotsQueryResponse, GetApiBookingSequentialSlotsQueryParams } from "../entities/GetApiBookingSequentialSlots";

function getGetApiBookingSequentialSlotsUrl() {
  const res = { method: 'GET', url: `/api/booking/sequential/slots` as const }
  return res
}

/**
 * @description Возвращает комбинации времени и мастеров для последовательной записи
 * @summary Получить доступные слоты для последовательной записи
 * {@link /api/booking/sequential/slots}
 */
export async function getApiBookingSequentialSlots(params: GetApiBookingSequentialSlotsQueryParams, config: Partial<RequestConfig> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config



  const res = await request<GetApiBookingSequentialSlotsQueryResponse, ResponseErrorConfig<Error>, unknown>({ method : "GET", url : getGetApiBookingSequentialSlotsUrl().url.toString(), params, ... requestConfig })
  return res.data
}